<evi-vertical-menu>
  <evi-vertical-menu-item
    [hasCustomContent]="true"
    [toggleCheckbox]="true"
  >
    <evi-checkbox
      label="Cursors"
      name="view-menu-toggle-cursors"
      displayStyle="toggle"
      [showToggleStyleTextIndicator]="true"
      [leftText]="true"
      [(ngModel)]="cursorsVisibility"
      (change)="handleToggleCursors($event.target.checked)"
    ></evi-checkbox>
  </evi-vertical-menu-item>

  <evi-vertical-menu-item
    [hasCustomContent]="true"
    [toggleCheckbox]="true"
  >
    <evi-checkbox
      label="Measures"
      name="view-menu-toggle-measures"
      data-testid="view-menu-measures-checkbox"
      displayStyle="toggle"
      [showToggleStyleTextIndicator]="true"
      [leftText]="true"
      [(ngModel)]="tooltipVisibility"
      (change)="handleToggleTooltip($event.target.checked)"
    ></evi-checkbox>
  </evi-vertical-menu-item>

  <evi-vertical-menu-item
    [hasCustomContent]="true"
    [toggleCheckbox]="true"
  >
    <evi-checkbox
      label="Gates"
      name="view-menu-toggle-gates"
      displayStyle="toggle"
      [showToggleStyleTextIndicator]="true"
      [(ngModel)]="gatesVisibility"
      [leftText]="true"
      (change)="handleToggleGates($event.target.checked)"
    ></evi-checkbox>
  </evi-vertical-menu-item>

  <evi-vertical-menu-item
    [hasCustomContent]="true"
    [toggleCheckbox]="true"
  >
    <evi-checkbox
      label="TCG"
      name="view-menu-toggle-tcg"
      displayStyle="toggle"
      [showToggleStyleTextIndicator]="true"
      [(ngModel)]="tcgVisibility"
      [leftText]="true"
      (change)="handleToggleTcg($event.target.checked)"
    ></evi-checkbox>
  </evi-vertical-menu-item>
</evi-vertical-menu>
